// extracted by mini-css-extract-plugin
module.exports = {"main":"Shortcut_main__19hcI","name":"Shortcut_name__e2_XG"};